import { Grid } from '@mantine/core';
import type { UseFormReturn } from 'react-hook-form';
import type { FormNames } from '../../../../../../react-commons/utils/form/getFormNames';
import { ResourceType } from '../../../../resource/enumerations/ResourceType';
import {
    GridElementDecoratorPropertyValidation,
    type GridElementDecoratorResource,
} from '../../../../resource/resources/artifacts/use_case/representation/gridElementDecoratorResource';
import { PropertyInputs } from '../../../reusable-components/base/property-bases/PropertyInputs';
import type { PropertyValidationInformation } from '../../../util/PropertyValidationInformation';

export const GridElementDecoratorContent = ({
    id,
    form,
    formNames,
    readOnly,
}: {
    id?: string;
    form: UseFormReturn<GridElementDecoratorResource>;
    formNames: FormNames<GridElementDecoratorResource>;
    readOnly: boolean;
}) => {
    const getPropertyValidationInformation = (
        propertyIdentifier: GridElementDecoratorPropertyValidation
    ): PropertyValidationInformation => ({
        resourceId: id,
        resourceType: ResourceType.GRID_ELEMENT_DECORATOR,
        propertyIdentifier,
    });

    return (
        <Grid>
            <Grid.Col span={6}>
                <PropertyInputs.Color
                    name={formNames.textColor}
                    control={form.control}
                    placeholder={'default color'}
                    nullable={true}
                    readOnly={readOnly}
                    propertyValidationInformation={getPropertyValidationInformation(
                        GridElementDecoratorPropertyValidation.TEXT_COLOR
                    )}
                />
            </Grid.Col>
            <Grid.Col span={6}>
                <PropertyInputs.Color
                    name={formNames.backgroundColor}
                    control={form.control}
                    placeholder={'default color'}
                    nullable={true}
                    readOnly={readOnly}
                    propertyValidationInformation={getPropertyValidationInformation(
                        GridElementDecoratorPropertyValidation.BACKGROUND_COLOR
                    )}
                />
            </Grid.Col>
        </Grid>
    );
};
